/**
 * Force download functionality for download buttons
 */
class DownloadButton {
  constructor() {
    this.init();
  }

  init() {
    // Find all download buttons and add event listeners
    const downloadButtons = document.querySelectorAll('[data-download-url]');
    downloadButtons.forEach(button => {
      // Check if listener already attached to prevent duplicates
      if (button.hasAttribute('data-download-initialized')) return;
      
      button.setAttribute('data-download-initialized', 'true');
      button.addEventListener('click', this.handleDownload.bind(this));
    });
  }

  async handleDownload(event) {
    event.preventDefault();
    
    const button = event.currentTarget;
    const downloadUrl = button.getAttribute('data-download-url');
    const filename = button.getAttribute('data-download-filename') || 'download';
    
    if (!downloadUrl) return;

    try {
      // Show loading state
      button.setAttribute('aria-disabled', 'true');
      const originalText = button.querySelector('.button__label').textContent;
      button.querySelector('.button__label').textContent = 'Downloading...';

      // Fetch the file
      const response = await fetch(downloadUrl);
      if (!response.ok) throw new Error('Download failed');

      // Convert to blob
      const blob = await response.blob();
      
      // Create download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = this.getFilename(downloadUrl, filename);
      
      // Trigger download
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Cleanup
      window.URL.revokeObjectURL(url);
      
      // Restore button state
      button.removeAttribute('aria-disabled');
      button.querySelector('.button__label').textContent = originalText;
      
    } catch (error) {
      console.error('Download failed:', error);
      
      // Fallback to regular link behavior
      window.open(downloadUrl, '_blank');
      
      // Restore button state
      button.removeAttribute('aria-disabled');
      button.querySelector('.button__label').textContent = button.querySelector('.button__label').getAttribute('data-label');
    }
  }

  getFilename(url, fallbackName) {
    // Try to extract filename from URL
    const urlParts = url.split('/');
    const lastPart = urlParts[urlParts.length - 1];
    
    // If URL has a filename with extension, use it
    if (lastPart && lastPart.includes('.')) {
      return lastPart.split('?')[0]; // Remove query parameters
    }
    
    // Otherwise use fallback name
    return fallbackName.includes('.') ? fallbackName : fallbackName + '.pdf';
  }
}

// Initialize when DOM is ready or immediately if already loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new DownloadButton());
} else {
  new DownloadButton();
}
